module.exports = __webpack_public_path__ + "img/icon-instagram.fb841898.jpg";